import "./landing.css";

interface ISectionHeader {
	eyebrow: string;
	title: string;
	light?: boolean;
	center?: boolean;
}

const SectionHeader = ({ eyebrow, title, light, center }: ISectionHeader) => (
	<header
		className={`ld-sh ${light ? "ld-sh-light" : ""} ${
			center ? "ld-sh-center" : ""
		}`}
	>
		<span className="ld-sh-eyebrow">{eyebrow}</span>
		<h2 className="ld-sh-title">{title}</h2>
		<span className="ld-sh-line" aria-hidden="true" />
	</header>
);

export default SectionHeader;
